var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 24.8242C25 26.2435 24.5931 27.4609 23.7793 28.4766C22.9655 29.4922 21.9857 30 20.8398 30H4.16016C3.01432 30 2.03451 29.4922 1.2207 28.4766C0.406901 27.4609 0 26.2435 0 24.8242C0 23.7174 0.0553385 22.6725 0.166016 21.6895C0.276693 20.7064 0.481771 19.7168 0.78125 18.7207C1.08073 17.7246 1.46159 16.8717 1.92383 16.1621C2.38607 15.4525 2.99805 14.873 3.75977 14.4238C4.52148 13.9746 5.39714 13.75 6.38672 13.75C8.09245 15.4167 10.1302 16.25 12.5 16.25C14.8698 16.25 16.9076 15.4167 18.6133 13.75C19.6029 13.75 20.4785 13.9746 21.2402 14.4238C22.002 14.873 22.6139 15.4525 23.0762 16.1621C23.5384 16.8717 23.9193 17.7246 24.2188 18.7207C24.5182 19.7168 24.7233 20.7064 24.834 21.6895C24.9447 22.6725 25 23.7174 25 24.8242ZM20 7.5C20 9.57031 19.2676 11.3379 17.8027 12.8027C16.3379 14.2676 14.5703 15 12.5 15C10.4297 15 8.66211 14.2676 7.19727 12.8027C5.73242 11.3379 5 9.57031 5 7.5C5 5.42969 5.73242 3.66211 7.19727 2.19727C8.66211 0.732422 10.4297 0 12.5 0C14.5703 0 16.3379 0.732422 17.8027 2.19727C19.2676 3.66211 20 5.42969 20 7.5Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.e341aa4ee0f08def636fac75941d0b56.svg";
export { ForwardRef as ReactComponent };